import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getCancellationReasons = createAsyncThunk(
  '/getCancellationReasons',
  async () => {
    const response = await axios.get('/GetCancellationReasons');
    return response.data;
  }
);
export const getCancellationReasonList = createAsyncThunk(
  '/getCancellationReasonList',
  async () => {
    const response = await axios.get('/GetCancellationReasonList');
    return response.data;
  }
);
export const getCancellationReasonDetails = createAsyncThunk(
  '/getCancellationReasonDetails',
  async (id) => {
    const response = await axios.get(`/GetCancellationReasonDetails/${id}`);
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const cancellationReasonSlice = createSlice({
  name: 'cancellationReason',
  initialState: {
    loading: false,
    error: '',
    cancellationReasons: [],
    cancellationReasonList: [],
    cancellationReasonDescriptions: [],
    SelectedAppTranslationId: 0,
    Type: '',
    cancellationReasonType: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    changeType(state, action) {
      state.Type = action.payload;
      //state.cancellationReasonType = state.cancellationReasonList.find((m) => m.Description === state.Type).ID;
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    resetDescriptions(state) {
      state.cancellationReasonDescriptions = [];
    }
    
  },

  extraReducers: {
    [getCancellationReasons.pending]: (state) => {
      state.loading = true;
    },
    [getCancellationReasons.cancellationed]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCancellationReasons.fulfilled]: (state, action) => {
      state.cancellationReasons = action.payload;
      state.loading = false;
    },
    [getCancellationReasonDetails.pending]: (state) => {
      state.loading = true;
    },
    [getCancellationReasonDetails.cancellationed]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCancellationReasonDetails.fulfilled]: (state, action) => {
      state.cancellationReasonDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: (state) => {
      state.loading = true;
    },
    [getLanguageList.cancellationed]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.cancellationReasonDescriptions = action.payload;
      state.loading = false;
    },
    [getCancellationReasonList.pending]: (state) => {
      state.loading = true;
    },
    [getCancellationReasonList.cancellationed]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCancellationReasonList.fulfilled]: (state, action) => {
      state.cancellationReasonList = action.payload;
      state.loading = false;
    }
  }
});

export const cancellationReasonActions = cancellationReasonSlice.actions;

export default cancellationReasonSlice;
